// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3LFnA","gfeWrapper":"CalendarEvent_gfeWrapper__2EiI4"};